<template>
  <el-select v-model="refVendorId" filterable=""
    style="vertical-align: top;"
    placeholder="请选择企业"
    @change="handleChange"
    clearable>
    <el-option v-if="showAll"
      label="全部"
      :value="null"></el-option>
    <el-option v-for="item in vendorNames"
      :key="item.vendorId"
      :label="item.vendorName"
      :value="item.vendorId">
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'assign-ent-select',
  props: {
    value: {
      required: true
    },
    callback: {
      type: Function
    },
    option: {
      type: Object
    },
    showAll: {
      type: Boolean,
      default: false
    },
    immediate: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      vendorNames: []
    }
  },
  watch: {
    'option.tagType': {
      handler (val, oldVal) {
        if (!this.immediate) {
          if (val && val !== oldVal) {
            this.getEntList()
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    refVendorId: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleChange () {
      this.callback && this.callback()
    },
    getEntList () {
      this.$store.dispatch('common/getvendornames', {
        payload: this.option,
        success: (res) => {
          this.vendorNames = res.data.vendorNames
        },
        fail: () => {
          this.vendorNames = []
        }
      })
    }
  },
  mounted () {
    if (this.immediate) {
      this.getEntList()
    }
  }
}
</script>
